import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=48654708"
import script from "./Site.vue?vue&type=script&lang=ts"
export * from "./Site.vue?vue&type=script&lang=ts"
import style0 from "./Site.vue?vue&type=style&index=0&id=48654708&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports